import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import {Box, Button, Checkbox, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, IconButton, MenuItem, Paper, Radio, RadioGroup, Select, TextField, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import formMappings from "app/pages/Docgen/constants/form_mappings";
import ModalPreloader from "app/pages/Docgen/utils/ModalPreloader";
import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import {get} from "../../../common/network";
import UploadFormModal from "./UploadFormModal";

const NewSubmissionModal = props => {

    const { newSubmissionModalOpen, setNewSubmissionModalOpen, handleFilingSubmit, selectedRows , submissionType} = props;
    const [formList,setFormList] = useState([]);
    const [loading,setLoading] = useState(false);
    const [checked, setChecked] = useState({});
    const [uploadedFiles,setUploadedFiles] = useState([]);
    const [pageCount,setPageCount] = useState("");
    const [claimsCount,setClaimsCount] = useState("");
    const [independentClaims,setIndependentClaims] = useState("");
    const [timeExtension,setTimeExtension] = useState("");
    const [terminalDisclaimers,setTerminalDisclaimers] = useState("");
    const [partOfApplication,setPartOfApplication] = useState(false);
    const [interfaceApplication,setInterfaceApplication] = useState(false);
    const [matterContacts, setMatterContacts] = useState([]);
    const [attorneyName, setAttorneyName] = useState("");
    const [searchFee,setSearchFee] = useState("");
    const [uploadModalOpen,setUploadModalOpen] = useState(false);

    const matterId = selectedRows[0]?.generated_form_matter?.id || selectedRows[0]?.id;
    const docketNumber = selectedRows[0]?.generated_form_matter?.host_file_number || selectedRows[0]?.host_file_number;

    const handleClose = () => {
        setNewSubmissionModalOpen(false);
    };

    const handleCheck = e => {
        setChecked({ ...checked, [e.target.id]: e.target.checked });
    };
      
    const handleDeleteForm = (clickedFileName) =>{
        setUploadedFiles(uploadedFiles.filter((p) => p.file.name!==clickedFileName))
    }
    const handleUpload = (e) => {
        for (let i = 0; i < e.target.files.length; i++) {
            let file = e.target.files[i];
            if (file?.name) {
                if (!uploadedFiles.some((p) => p.file.name === file.name)) {
                    setUploadedFiles((prev) => [...prev, {modifiedName: "", category: "", description: "", file: file}])
                } else {
                    toast.error(`${file.name} - File already uploaded`);
                }
            }
        }
        setUploadModalOpen(true);
        e.target.value = null;
    }
      
      const fetchData = async () => {
        try {
          const response = await get(
              `docgen/generate-forms`                    
              );
          const filteredData = response?.data?.filter((item)=> item.generated_form_matter.host_file_number === docketNumber)
          setFormList(filteredData);
        } catch (error) {
        }
      };

      const fetchContacts = async () => {
        try {
            const response =
                await get(
                    `docgen/matters/${matterId}` 
                );
            setMatterContacts(response?.data?.matter_parties || []);
        } catch (error) {
        }
    };
    
    useEffect(() => {
        const fetchInfo = async () => {
          setLoading(true);
          await Promise.all([fetchData(), fetchContacts()]);
          setLoading(false);
        };
      
        fetchInfo();
      }, []);

        const handleSubmit = () => {
            const formData = new FormData();

            const selectedUploadedFiles = uploadedFiles.filter((form) => checked[form.file.name]===true);

            selectedUploadedFiles.forEach((file) => {
            formData.append("files", JSON.stringify(file));
            });

            const selectedForms = formList.filter(form => checked[form.id] === true);
            
            formData.append("forms",selectedForms);
            formData.append("pageCount",pageCount);
            formData.append("partOfApplication",partOfApplication);
            formData.append("attorneyName",attorneyName);

            if (submissionType === "existing-submission" || submissionType === "371") {
                formData.append("searchFee",searchFee);
            }

            if (submissionType === "non-provisional" || submissionType === "existing-submission" || submissionType === "371") {
                formData.append("claimsCount",claimsCount);
                formData.append("independentClaims",independentClaims);
            }

            if (submissionType==="existing-submission") {
                formData.append("timeExtension",timeExtension);
                formData.append("terminalDisclaimers",terminalDisclaimers);
                formData.append("interfaceApplication",interfaceApplication);
            }
        }

    
     const useStyles = makeStyles({
        smallRadio: {
            "& svg": {
                width: 20,
                height: 20
            },
            "& svg > circle": {
                width: 12,
                height: 12
            }
        }
    });
    const classes = useStyles();

    const submissionTypeHeader = () =>{
        if (submissionType === "non-provisional"){
            return "NON-PROVISONAL FILING"
        } 
        if (submissionType === "provisional"){
            return "PROVISONAL FILING"
        }
        if (submissionType === "371") {
            return "371 FILING"
        } 
        if (submissionType === "existing-submission"){
            return "EXISTING SUBMISSION"
        } 
    }

    return (
        <div style={{width:"100%"}}>
          
            <Dialog open={newSubmissionModalOpen} onClose={handleClose} aria-labelledby="form-dialog-title"  fullWidth maxWidth="lg">
            {loading ? <ModalPreloader />: <>
            <DialogTitle id="form-dialog-title">
              <Typography align="center" sx={{ fontWeight: 'bold' }}>{`Docket Number: ${docketNumber}`}</Typography>
              <br></br>
              
              <Box display="flex" justifyContent="space-between">
                <Button variant="contained" color="primary" onClick={()=> {}} sx={{ mr: 2}}>
                    {submissionTypeHeader()}
                </Button>
                <Button variant="outlined" color="primary" onClick={()=> {}} >
                    Back
                </Button>
              </Box>
            </DialogTitle>
                <DialogContent>
                <Paper>
                    <br></br>
                    {formList?.length>0 || uploadedFiles.length>0 ? <Typography sx={{marginLeft:"1%"}}>*Please select the forms for filing:</Typography> :
                                        <Typography color='red'>No forms generated corresponding to the selected docket, please upload or generate new forms</Typography>}
                   

                    
                    <Box sx={{ display: 'flex', flexDirection: 'column'}}>
                        {
                            formList?.map((item) => {
                                if (formMappings[item?.generated_form?.form_code]) {
                                    return (
                                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                            <Checkbox id={item?.id} checked={checked[item?.id] || false} onChange={e => handleCheck(e)}/>
                                            <Box key = {item?.id} sx={{ bgcolor: 'lightblue', color: 'black', p: 1, mb: 1, mt:1,textAlign: 'left' }}>
                                                {`${docketNumber}_${formMappings[item?.generated_form?.form_code]}`}
                                            </Box>
                                        </Box>
                                    )
                              
                                }
                            })

                        }

                        {uploadedFiles.filter(Boolean).map((item) => 
                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                    <Checkbox id={item?.file?.name} checked={checked[item?.file?.name] || false} onChange={e => handleCheck(e)}/>
                                    <Box key = {item?.file?.name} sx={{ bgcolor: 'lightblue', color: 'black', p: 1, mb: 1, mt:1,textAlign: 'left' }}>
                                        {item?.file?.name}
                                    </Box>
                                    <Button 
                                        onClick={()=> handleDeleteForm(item?.file?.name)}
                                        sx={{ color: 'red' }}
                                    >
                                        &#10005; 
                                    </Button>
                                </Box>
                        )}
                    </Box>
                   
                    </Paper>
                    <input id="file-upload" type="file" style={{ display: 'none' }} onChange={handleUpload} accept=".pdf" multiple/>
                    <Box display="flex" justifyContent="space-between">
                        <Box flexGrow={1} />
                        <IconButton onClick={() => { document.getElementById('file-upload').click(); }}>
                            <CloudUploadOutlinedIcon /> &nbsp;
                            <Typography variant="body2">Upload</Typography>
                        </IconButton>
                    </Box>
                    
                   
                    <Paper>
                        <br></br>

                        {(submissionType === "existing-submission" || submissionType === "371") && <RadioGroup row={true} name="national-stage-search-fee" value={searchFee} onChange={(e) => setSearchFee(e.target.value)}>
                                <Box  sx={{ display: 'flex', flexDirection: 'column',marginLeft:"1.5%",mb:2}}>
                                    <FormControlLabel value="us-isa" control={<Radio className={classes.smallRadio} />} label="National Stage Search Fee –US was the ISA" />
                                    <FormControlLabel value={"prepared"} control={<Radio className={classes.smallRadio} />} label="National Stage Search Fee - search report prepared and provided to USPTO" />
                                    <FormControlLabel value={"others"} control={<Radio className={classes.smallRadio} />} label="National Stage Search Fee - All other situations" />
                                </Box>
                                <br></br>
                            </RadioGroup>}
                      

                        <Box sx={{marginLeft : "1.5%"}}>
                            <Box  sx={{ display: 'flex', alignItems: 'center'}}>
                                <Typography variant="body2">Number of pages in the specification (including any external tables) and drawings</Typography>
                                <TextField name="pageCount" value={pageCount} size="small" label="" fullWidth={false} onChange={(e)=> setPageCount(e.target.value)} sx={{ marginLeft: "1%", width:"10%" }}></TextField>
                            </Box>

                            {(submissionType === "existing-submission" || submissionType === "non-provisional" || submissionType === "371") && <>
                                <Box  sx={{ display: 'flex', alignItems: 'center'}}>
                                    <Typography variant="body2">Number of claims</Typography>
                                    <TextField name="pageCount" value={claimsCount} size="small" label="" fullWidth={false} onChange={(e)=> setClaimsCount(e.target.value)} sx={{ marginLeft: "1%", width:"5%" }}></TextField>
                                </Box>

                            <Box  sx={{ display: 'flex', alignItems: 'center'}}>
                                    <Typography variant="body2">Number of independent claims</Typography>
                                    <TextField name="pageCount" value={independentClaims} size="small" label="" fullWidth={false} onChange={(e)=> setIndependentClaims(e.target.value)} sx={{ marginLeft: "1%", width:"5%" }}></TextField>
                                </Box>

                                {submissionType==="existing-submission" && <>
                                    <Box  sx={{ display: 'flex', alignItems: 'center'}}>
                                        <Typography variant="body2">Extension of time –previously paid amount </Typography>
                                        <TextField name="pageCount" value={timeExtension} size="small" label="" fullWidth={false} onChange={(e)=> setTimeExtension(e.target.value)} sx={{ marginLeft: "1%", width:"5%" }}></TextField>
                                    </Box>

                                    <Box  sx={{ display: 'flex', alignItems: 'center'}}>
                                        <Typography variant="body2">Number of statutory or terminal disclaimer(s)</Typography>
                                        <TextField name="pageCount" value={terminalDisclaimers} size="small" label="" fullWidth={false} onChange={(e)=> setTerminalDisclaimers(e.target.value)} sx={{ marginLeft: "1%", width:"5%" }}></TextField>
                                    </Box>
                                </>}
                            </>}
                        </Box>

                        <br></br>
                        <Typography variant="body2" sx={{marginLeft : "1.5%"}}>Petitions</Typography>
                        <Box sx={{ display: 'flex', flexDirection:"column"}}>
                            <Box  sx={{ display: 'flex', alignItems: 'center'}}>
                                <Checkbox id={"part-of-application"} checked={partOfApplication} onChange={e => setPartOfApplication(e.target.checked)}/>
                                <Typography variant="body2">Check the box if you are filing petition(s) as part of this application</Typography>
                            </Box>
                            
                            {submissionType==="existing-submission" && <>
                            <Box  sx={{ display: 'flex', alignItems: 'center'}}>
                                <Checkbox id={"interface-of-application"} checked={interfaceApplication} onChange={e => setInterfaceApplication(e.target.checked)}/>
                                <Typography variant="body2">Check the box if you are filing patent appeals and interface requires as part of this application</Typography>
                            </Box>
                            </>}
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center',marginLeft : "4.5%"}}>
                            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>*Submitted on behalf of: </Typography>
                            <FormControl sx={{marginLeft:"5%"}}>
                                <Select size="small" name="attorney" value={attorneyName} onChange={(e)=>setAttorneyName(e.target.value)} fullWidth={false} displayEmpty renderValue={attorneyName !== "" ? undefined : () => "Select the Attorney"}>
                                    {matterContacts?.filter(p => p.party_type === "Attorney")?.length === 0 ? (
                                        <MenuItem value="">No Attorneys available</MenuItem>
                                    ) : (
                                        matterContacts
                                            ?.filter(p => p.party_type === "Attorney")
                                            ?.map(item => (
                                                <MenuItem key={item.id} value={item.party.name} size="small">
                                                    {item.party.name}
                                                </MenuItem>
                                            ))
                                    )}
                                </Select>
                            </FormControl>
                        </Box>
                        <br></br>
                    </Paper>
                    <br></br>
                    <Box display="flex" justifyContent="space-between">
                        <Box flexGrow={1} />
                        <Button variant="outlined" color="primary" onClick={()=> {}} sx={{ mr: 2}}>
                            Cancel
                        </Button>

                        <Button 
                            variant="contained" 
                            color="primary" 
                            sx={{ mr: 2}} 
                            disabled={!(attorneyName!=="" && Object.values(checked).filter((p)=> p===true).length > 0)}
                            onClick={handleSubmit} 
                        >
                            Submit
                        </Button>
                    </Box>
                     
                   
                </DialogContent>
            </>}
            
            </Dialog>

        {uploadModalOpen && 
            <UploadFormModal 
              uploadModalOpen={uploadModalOpen}
              setUploadModalOpen={setUploadModalOpen}
              formList={formList}
              uploadedFiles = {uploadedFiles}
              setUploadedFiles={setUploadedFiles}
              formMappings={formMappings}
              />}

        </div>

    );
};

export default NewSubmissionModal;